import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Home.css";

import icon1 from "./assets/icon1.png";
import icon1Hover from "./assets/icon1-hover.png";
import icon2 from "./assets/icon2.png";
import icon2Hover from "./assets/icon2-hover.png";
import icon3 from "./assets/icon3.png";
import icon3Hover from "./assets/icon3-hover.png";
import icon4 from "./assets/icon4.png";
import icon4Hover from "./assets/icon4-hover.png";
import icon5 from "./assets/icon5.png";
import icon5Hover from "./assets/icon5-hover.png";
import icon6 from "./assets/icon6.png";
import icon6Hover from "./assets/icon6-hover.png";
import icon7 from "./assets/icon7.png";
import icon7Hover from "./assets/icon7-hover.png";
import riarr from "./assets/Rightarr.svg";

const products = [
  {
    id: "workforce",
    name: "Workforce Scheduler",
    description: "Schedules resources efficiently for maximum productivity.",
    icon: icon1,
    hoverIcon: icon1Hover,
    link: "/workforce-scheduler",
  },
  {
    id: "workload",
    name: "Operational Workload Planning",
    description: "Manage vessel, equipment, and labor efficiently.",
    icon: icon2,
    hoverIcon: icon2Hover,
    link: "/operational-workload-planning",
  },
  {
    id: "capacity",
    name: "Capacity Planning",
    description: "Addresses pre- and post-shift changes accurately, timely.",
    icon: icon3,
    hoverIcon: icon3Hover,
    link: "/capacity-planning",
  },
  {
    id: "allocation",
    name: "Automated Work Allocation & Assignment",
    description: "Automatically assigns manpower based on defined rules.",
    icon: icon4,
    hoverIcon: icon4Hover,
    link: "/automated-work-allocation-assignment",
  },
  {
    id: "self-service",
    name: "Employee Self Service",
    description: "Employees manage leave, schedules, and work online.",
    icon: icon5,
    hoverIcon: icon5Hover,
    link: "/employee-self-service",
  },
  {
    id: "attendance",
    name: "Time & Attendance",
    description: "Manages employee attendance via time clock interface.",
    icon: icon6,
    hoverIcon: icon6Hover,
    link: "/time-attendance",
  },
  {
    id: "connected",
    name: "Connected Systems",
    description: "Integration with Port Terminal Operation Platforms.",
    icon: icon7,
    hoverIcon: icon7Hover,
    link: "/connected-systems",
  },
];

const HomeProducts = () => {
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <>
      <section className="w-full px-[5%] max-w-[1200px] mx-auto mt-[60px] text-center font-epilogue">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="text-[#181835] font-semibold text-[32px] mb-5"
        >
          Our products
        </motion.h2>

        <p className="text-[#6B7280] text-[16px] max-w-[700px] mx-auto">
          For empowering your workforce through intelligent planning and automation
        </p>
      </section>

      <section className="w-full bg-white py-[40px] font-epilogue">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-[24px] px-[5%] max-w-[1300px] mx-auto">
          {products.map((product, index) => (
            <motion.div
              key={product.id}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => navigate(product.link)}
              className={`
                product-card
                ${hoveredIndex === index ? "active" : ""}
                ${index % 2 === 0 ? "border-blue" : "border-green"}
              `}
            >
              <div className="flex items-start gap-4">
                <img
                  src={hoveredIndex === index ? product.hoverIcon : product.icon}
                  alt={product.name}
                  className="w-[48px] h-[48px] object-contain transition-all duration-300"
                />

                <div className="flex flex-col text-left">
                  <div className="flex items-center gap-2">
                    <h3 className="text-[16px] font-semibold text-[#0A0A0A]">
                      {product.name}
                    </h3>
                    <img src={riarr} alt="arrow" className="w-[16px] h-[16px]" />
                  </div>

                  <p className="text-[14px] text-[#333] mt-2">
                    {product.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </>
  );
};

export default HomeProducts;
